<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'Incubator'
    };
</script>

<style lang="less" scoped>
</style>